<template>
  <div class="page clinic-detail">
    <clinic-detail-skeleton
      v-if="loading"
      style="margin-bottom: 100vh"
    ></clinic-detail-skeleton>

    <div v-else>
      <div class="clinic-detail-box">
        <div class="clinic-detail-header-bg"></div>
        <div class="clinic-detail-header">
          <div class="clinic-detail-header-title">
            <span>招募</span>
            {{ detail.title }}
          </div>
          <div class="clinic-detail-header-tags">
            <van-tag
              color="#95E9DD"
              plain
              text-color="#08C0B5"
              v-for="val in detail.tags_list"
              :key="val.id"
              size="medium"
              >{{ val.name }}</van-tag
            >
          </div>
          <div class="clinic-detail-header-content">
            <div class="clinic-detail-items">
              <div class="clinic-detail-items-lable">项目描述</div>
              <div class="clinic-detail-items-value">{{ detail.desc }}</div>
            </div>
            <div class="clinic-detail-items" v-if="detail.project_pi">
              <div class="clinic-detail-items-lable">
                <span class="clinic-list-items-lable-span">项目描述</span>
                <span class="clinic-list-items-lable-span2">项目PI</span>
              </div>
              <div class="clinic-detail-items-value">
                {{ detail.project_pi || "--" }}
              </div>
            </div>
            <div class="clinic-detail-items" v-if="detail.deal_company">
              <div class="clinic-detail-items-lable">实施单位</div>
              <div class="clinic-detail-items-value">
                {{ detail.deal_company || "--" }}
              </div>
            </div>
            <div class="clinic-detail-items">
              <div class="clinic-detail-items-lable">发布日期</div>
              <div class="clinic-detail-items-value">
                {{ detail.end_time || "--" }}
              </div>
            </div>
          </div>
        </div>

        <div class="clear" style="margin-top: 15px"></div>
        <div>
          <div class="clinic-detail-content">
            <div class="rich_media_inner" v-html="detail.content"></div>
          </div>
        </div>
      </div>

      <img
        @click="goWechat()"
        class="course-detail-share-button"
        src="/static/bytx/btn_assess.svg"
        alt=""
      />

      <div class="clinic-detail-footer">
        <div class="clinic-detail-footer-box">
            <van-button
              class="clinic-detail-footer-left-btn"
              type="danger"
              round
              plain
              size="large"
              @click="openShareData"
              color="#0FB7AD"
            >
              分享给病友
            </van-button>
            <!-- <van-grid :column-num="3" :border="false">
              <van-grid-item
                @click="favorite()"
                v-if="detail.isFavorite"
                icon="/static/img/course/icon_course_favorite_on_20.svg"
                text="已收藏"
              />
              <van-grid-item
                @click="favorite()"
                v-else
                icon="/static/img/course/icon_course_favorite_off_20.svg"
                text="收藏"
              />
              <van-grid-item
                @click="pointLike()"
                v-if="detail.isLike"
                icon="/static/img/course/icon_course_like_on.svg"
                text="有帮助"
                :badge="detail.like_count"
              />
              <van-grid-item
                @click="pointLike()"
                v-else
                icon="/static/img/course/icon_course_like_off.svg"
                text="有帮助"
                :badge="detail.like_count"
              />
              <van-grid-item
                @click="openShareData"
                icon="/static/img/course/icon_course_share_20.svg"
                text="转发"
              />
            </van-grid> -->
            <van-button
              class="clinic-detail-footer-right-btn"
              type="danger"
              round
              size="large"
              @click="mApply"
              color="#0FB7AD"
            >
              {{ detail.isApply ? "已申请" : "我要申请" }}
            </van-button>
        </div>
        <van-number-keyboard safe-area-inset-bottom />
      </div>
      <!--
      <van-dialog
        class="feedback"
        v-model="openFeedback"
        :showConfirmButton="false"
      >
        <template slot="title">
          <div class="close-pop" @click="openFeedback = false">
            <img src="/static/bytx/popup_close_icon.svg" alt="" />
          </div>
          <h3>联系小助手</h3>
        </template>

        <div class="clear"></div>

        <div>
          战友您好，请您长按识别下方二维码添加小助手，博医同行将因您变得更好。
        </div>

        <div align="center" style="margin-top: 10px">
          <img src="/static/bytx/kefu.svg" alt="" />
        </div>
      </van-dialog> -->

      <van-dialog
        class="apply_form"
        v-model="applyFormDialog"
        :showConfirmButton="false"
      >
        <template slot="title">
          <div class="close-pop" @click="closeApplyForm">
            <img src="/static/bytx/popup_close_icon.svg" alt="" />
          </div>
          <h3 v-if="!detail.isApply">申请临床新药</h3>
          <h3 v-else>您已申请，无需重复提交！</h3>
        </template>
        <div class="clear"></div>
        <div v-if="!detail.isApply">
          为核实申请信息，为您申请临床新药项目，需您完善真实信息。
        </div>
        <div v-else style="text-align: center">
          请将项目名发给小助手，获取报名表或链接
        </div>
        <div
          v-if="!detail.isApply"
          align="center"
          style="margin-top: 12px;color: #9D9D9D"
        >
          <van-button
            class="clinic-detail-footer-right-btn"
            type="danger"
            round
            size="large"
            @click="goLogin()"
            color="#0FB7AD"
          >
            立即填写
          </van-button>
        </div>
        <div v-else style="text-align: center">
          <img width="220" :src="apply_qrcode" alt="" />
          <div>长按识别添加</div>
        </div>
      </van-dialog>

      <van-overlay :show="showShareDialog" @click="showShareDialog = false">
        <div class="share-box">
          <div class="block">
            请点击 “...”，再点击发送给朋友 | <span>知道啦</span>
          </div>
          <div
            class="share-box-bottom"
            style="left: 120px;bottom:-10px;right: auto"
          >
            <img src="/static/bytx/detail_forward_2_img.png" alt="" />
          </div>
        </div>
      </van-overlay>
    </div>
    <van-dialog
      v-model="wxdialog"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="kf-dialog"
    >
      <img
        class="wx-dialog-kf-header"
        src="/static/bytx/kf-popup_head.png"
        alt=""
      />
      <van-icon name="cross" class="close-btn" @click="wxdialog = false" />
      <p class="wx-dialog-kf-content">
        联系专属客服，有助于快速入组
      </p>
      <div class="wx-dialog-kf-btn">
        <van-button
          round
          icon="phone"
          @click="goPhone"
          plain
          color="#05C8BC"
          type="primary"
          >电话沟通</van-button
        >
        <van-button
          @click="goWechat"
          round
          icon="wechat"
          color="linear-gradient(180deg, #41D6D4 0%, #49E6C8 100%)"
          type="primary"
          >微信沟通</van-button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Interface from "@/util/interface";
import clinicDetailSkeleton from "@/skeleton/articleDetailSkeleton";
import checkLogin from "../../../mixins/checkLogin";
import { LocationHref } from "@/util/common";

export default {
  name: "clinic-detail",
  mixins: [checkLogin],
  components: {
    "clinic-detail-skeleton": clinicDetailSkeleton
  },
  data() {
    return {
      id: 0,
      value: "",
      active: "",
      category_id: 0,
      category_child_id: 0,
      banners: [],
      categories: [],
      categories_child: [],
      recommend: [],
      list: [],
      column: [],
      clinic: {},
      comment: [],
      comment_text: "",
      loading: true,
      share_data: {},
      showShareDialog: false,
      htmlUrl: "",
      isShow: false,
      status: "",
      comment_id: 0,
      to_user_id: 0,
      comment_placeholder: "写评论",
      user_id: 0,
      detail: {},
      applyFormDialog: false,
      openFeedback: false,
      record_id: "",
      timer: null,
      apply_qrcode: "/static/qrcode/lczm.png",
      wxdialog: false
    };
  },
  methods: {
    fetch(scene) {
      if (scene === "detail") {
        Interface.getData("get", Interface.clinic.detail + this.id).then(
          res => {
            this.detail = res.data;
            setTimeout(() => {
              this.loading = false;
            }, 500);
            if (this.detail) {
              Interface.getShareInfo(
                this,
                this.detail.title,
                this.detail.cover_img,
                this.detail.desc
              );
              Interface.getData("post", Interface.footprint, {
                id: this.id,
                type: 7,
                content_type: 0,
                page_type: 4,
                source_type: 0,
                parent_id: 0,
                record_id: 0,
                title: this.detail.title
              }).then(res => {
                if (res.code == 0) {
                  this.record_id = res.data.record_id;
                }
              });

              if (this.detail.category_id == "27") {
                // 实体肿瘤
                this.apply_qrcode = "/static/qrcode/zm_27.png";
              }
            }
          }
        );
      } else if (scene === "footprint") {
        let params = {
          id: this.id,
          type: 7
        };
        Interface.getData("post", Interface.footprint, params).then(res => {});
      }
    },
    changeCategory() {
      this.fetch("clinic");
    },
    favorite() {
      Interface.getData("get", Interface.clinic.favorite + this.id).then(
        res => {
          if (res.code == 0) {
            this.detail.isFavorite = !this.detail.isFavorite;
          }
        }
      );
    },
    pointLike() {
      Interface.getData("get", Interface.clinic.like + this.id).then(res => {
        if (res.code == 0) {
          this.detail.like_count = this.detail.isLike
            ? parseInt(this.detail.like_count) - 1
            : parseInt(this.detail.like_count) + 1;
          this.detail.isLike = !this.detail.isLike;
        }
      });
    },
    reComment(item) {
      this.comment_placeholder = "回复" + item.nickname;
      this.comment_id = item.id;
    },
    reCommentChild(item) {
      this.comment_placeholder = "回复" + item.nickname;
      this.comment_id = item.comment_id;
      this.to_user_id = item.user_id;
    },
    pointLikeComment(item) {
      Interface.getData("get", Interface.pointLikeComment + item.id).then(
        res => {
          if (res.code == 0) {
            item.isLike = !item.isLike;
            if (item.isLike) {
              item.like_count += 1;
            } else {
              item.like_count -= 1;
            }
          }
        }
      );
    },
    goComment() {
      this.$el.querySelector(".comment").scrollIntoView();
    },
    openShareData() {
      this.showShareDialog = true;
    },

    goLogin() {
      let user = localStorage.getItem("user");
      if (user != null) {
        user = JSON.parse(user);
      } else {
        user = {};
      }
      sessionStorage.setItem("back-url", this.$route.path);
      sessionStorage.setItem(
        "apply",
        JSON.stringify({
          apply: "clinic",
          apply_id: this.id,
          apply_category_id: this.detail.category_id
        })
      );
      this.goAddInfo(user);
    },
    closeApplyForm() {
      this.applyFormDialog = false;
    },
    goWechat() {
      LocationHref(this.detail.help_link);
    },
    mApply() {
      this.applyFormDialog = true;
      Interface.mFootPrint(
        this.id,
        72,
        0,
        4,
        0,
        "",
        0,
        "临床招募-申请救助",
        this.detail.title
      );
    },
    goPhone() {
      window.location.href = `tel://${this.detail.phone}`;
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.fetch("detail");
    // this.fetch('footprint')
    this.timer = setInterval(() => {
      if (this.record_id) {
        Interface.mFootPrint(
          this.id,
          7,
          0,
          5,
          0,
          this.id,
          this.record_id,
          this.detail.title
        );
      }
    }, 6000);
    this.wxdialog = true;
  },
  beforeRouteLeave(to, from, next) {
    if (this.record_id) {
      Interface.mFootPrint(
        this.id,
        7,
        0,
        5,
        0,
        this.id,
        this.record_id,
        this.detail.title
      );
    }
    clearInterval(this.timer);
    next();
  }
};
</script>

<style lang="scss">
@import "./index";
@import "../../../components/comment";
</style>



// WEBPACK FOOTER //
// src/views/clinic/detail/index.vue